"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusFieldLogic = void 0;
const sortBy_1 = __importDefault(require("lodash-es/sortBy"));
const texts_1 = require("../../texts");
const types_1 = require("@smartsuite/types");
const field_logic_1 = require("../../field-type-registry/field-logic");
const status_fieldtype_1 = require("../../safe-field-value/status-field/status.fieldtype");
const comparisons_1 = require("../../comparisons/comparisons");
const clipboard_1 = require("../../clipboard/clipboard");
const clipboard_2 = require("../../clipboard");
const validation_1 = require("../../validation");
const fields_1 = require("../../utils/fields");
const object_1 = require("../../utils/object");
const isArray_1 = __importDefault(require("lodash-es/isArray"));
const color_1 = require("../../utils/color");
const intl_1 = require("../../locale/intl");
const validation_2 = require("../../validation/validation");
const migrations_1 = require("../../migrations/migrations");
const status_1 = require("../../utils/status");
const filter_1 = require("../../utils/filter");
const type_guards_1 = require("../../utils/type-guards");
const sort_1 = require("../../sort");
class StatusFieldLogic extends field_logic_1.BaseFieldTypeLogic {
    constructor() {
        super(...arguments);
        this.name = "statusfield";
        this.label = (0, intl_1.$t)(texts_1.statusFieldText.status);
        this.icon = "status";
        this.iconColor = "#FF5757";
        this.placeholder = (0, intl_1.$t)(texts_1.statusFieldText.select_status);
        this.choiceMaxLength = 30;
        this.fieldValueGetter = new status_fieldtype_1.StatusFieldValueGetter();
        // @ts-expect-error: Need to resolve
        this.comparisons = {
            is: comparisons_1.is,
            is_not: comparisons_1.isNot,
            is_empty: comparisons_1.isEmpty,
            is_not_empty: comparisons_1.isNotEmpty,
            is_any_of: comparisons_1.isAnyOf,
            is_none_of: comparisons_1.isNoneOf,
            contains: comparisons_1.contains,
            is_completed: comparisons_1.isAnyOf,
            is_not_completed: comparisons_1.isNoneOf,
        };
        // @ts-expect-error: Need to resolve
        this.clipboardPasteRules = {
            statusfield: clipboard_2.clipboardStatusFieldToSelf,
            textfield: clipboard_1.clipboardTextToStatusField,
            recordtitlefield: clipboard_1.clipboardTextToStatusField,
            textareafield: clipboard_1.clipboardTextToStatusField,
            richtextareafield: clipboard_1.clipboardTextToStatusField,
            linkedrecordfield: clipboard_1.clipboardReferenceFieldToStatusField,
            singleselectfield: clipboard_1.clipboardSingleSelectToStatusField,
            multipleselectfield: clipboard_1.clipboardMultipleSelectToStatusField,
            tagsfield: clipboard_1.clipboardTagsToStatusField,
            unknownfield: clipboard_1.clipboardTextToStatusField,
        };
        this.getColoredChoices = (field) => {
            var _a;
            return (0, color_1.getColoredChoices)((_a = field.params.choices) !== null && _a !== void 0 ? _a : []);
        };
    }
    get validators() {
        const uniqueValidator = (0, validation_2.uniqueRecordFieldValueWithContext)({
            checkUniqueness: this.appRecordsService.checkUniqueness.bind(this.appRecordsService),
        });
        return { required: validation_1.requiredStatusField, unique: uniqueValidator };
    }
    getInlineEditRules(field) {
        return {
            ...super.getInlineEditRules(field),
            editOnStartTyping: false,
            editorWidth: "100%",
            canDeleteValue: true,
            switchToInputControl: "OnCellClick",
            saveKeys: [],
            enablePasteEventInEditMode: true,
        };
    }
    isValueEmpty(fieldValue) {
        return !(fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.value);
    }
    getEmptyValue() {
        return { value: "", updated_on: null };
    }
    sortKey(fieldValue, field) {
        return (0, sort_1.getListFieldOrderValue)((0, fields_1.getFieldChoiceByValue)(field, fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.value));
    }
    useSortCache() {
        return false;
    }
    useNaturalSorting(field, fieldValue, isGroupByRule) {
        return false;
    }
    groupByKey(fieldValue, field) {
        return this.sortKey(fieldValue, field);
    }
    processFieldValue(record, slug, comparison, field) {
        const fieldValue = super.processFieldValue(record, slug, comparison, field);
        return (fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.value) || "";
    }
    processFilterValue(filterValue, comparison, field) {
        if (["is_completed", "is_not_completed"].includes(comparison)) {
            return (0, status_1.getChoicesValuesWithIsCompleteStatus)(field);
        }
        return super.processFilterValue(filterValue, comparison, field);
    }
    filterToRecordValue(filterValue, comparison, field) {
        var _a, _b;
        const validValues = (_b = (_a = field.params.choices) === null || _a === void 0 ? void 0 : _a.map(({ value }) => value)) !== null && _b !== void 0 ? _b : [];
        if (comparison === "is" && validValues.includes(filterValue)) {
            return { value: filterValue, updated_on: null };
        }
        throw new types_1.FilterToRecordValueConversionError(field, filterValue, comparison);
    }
    valueToString(fieldValue, field) {
        return (0, fields_1.getFieldChoiceLabel)(field, fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.value);
    }
    migrateField(fieldTo, fieldFrom) {
        const fieldChoices = fieldTo.params.choices;
        const choicesCount = fieldChoices.length;
        if (choicesCount === 0) {
            // add default choices
            const params = this.params;
            fieldTo.params.choices = params.choices.map((choice) => ({
                ...choice,
            }));
        }
        else {
            // set is-completed flag to the last choice if it doesn't exist
            const hasCompleteChoice = fieldChoices.some((choice) => choice.is_complete);
            if (!hasCompleteChoice) {
                fieldTo.params.choices = fieldChoices.map((choice, index) => {
                    if (index === choicesCount - 1) {
                        return { ...choice, is_complete: true };
                    }
                    return choice;
                });
            }
        }
        return (0, migrations_1.migrateBaseField)(fieldTo, fieldFrom);
    }
    getFilterComponentData(field, comparison) {
        return {
            ...super.getFilterComponentData(field, comparison),
            choices: field.params.choices,
        };
    }
    isValueEqual(fieldValue1, fieldValue2) {
        return (fieldValue1 === null || fieldValue1 === void 0 ? void 0 : fieldValue1.value) === (fieldValue2 === null || fieldValue2 === void 0 ? void 0 : fieldValue2.value);
    }
    isGroupHighlighted(_field) {
        return true;
    }
    getChoiceByRecordValue(record, field) {
        var _a, _b;
        const recordValue = (0, fields_1.getValueFromRecordByField)(record, field);
        if (checkIsStatusFieldValue(recordValue)) {
            return ((_b = (_a = field.params.choices) === null || _a === void 0 ? void 0 : _a.find(({ value }) => recordValue.value === value)) !== null && _b !== void 0 ? _b : null);
        }
        return null;
    }
    filterValueToString(filterValue, field, userPreferences, comparison) {
        if (comparison &&
            ["is_empty", "is_not_empty", "is_completed", "is_not_completed"].includes(comparison)) {
            return "";
        }
        if (!(0, isArray_1.default)(filterValue) ||
            (comparison && ["is", "is_not", "contains"].includes(comparison))) {
            return this.valueToString({ value: filterValue, updated_on: null }, field);
        }
        // for an is_any_of and is_none_of filterValue is a list of statuses
        return filterValue
            .map((status) => this.valueToString({ value: status, updated_on: null }, field))
            .join(", ");
    }
    getLinkedRecordFieldSmartWidth(_field) {
        return {
            defaultWidht: 170,
            minWidth: 90,
        };
    }
    reloadOnMigrate(field, filters) {
        return ((0, filter_1.isFilterFieldExists)(filters, field.slug, "is_completed") ||
            (0, filter_1.isFilterFieldExists)(filters, field.slug, "is_not_completed"));
    }
    getSpotlightColorizer(field) {
        var _a;
        const choices = (_a = field.params.choices) !== null && _a !== void 0 ? _a : [];
        const colorsMap = new Map(choices.map(({ value, value_color }) => [value, value_color]));
        return (fieldValue) => {
            var _a;
            return (_a = colorsMap.get(fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.value)) !== null && _a !== void 0 ? _a : null;
        };
    }
    getSpotlightColorChoices(field) {
        var _a;
        const choices = (0, sortBy_1.default)((_a = field.params.choices) !== null && _a !== void 0 ? _a : [], "value_order");
        return choices.map(({ value, label, value_color }) => ({
            value,
            label,
            color: (0, type_guards_1.isNotNullOrUndefined)(value_color) ? value_color : "",
        }));
    }
    shouldCleanUpEmptyInLookupFilter(comparison) {
        return !["is_not_completed"].includes(comparison);
    }
}
exports.StatusFieldLogic = StatusFieldLogic;
const checkIsStatusFieldValue = (object) => {
    return (0, object_1.isObject)(object) && "value" in object;
};
